<template>
  <section
    :class="'wrapper ' + cssClass"
    :style="cssStyle"
  >
    <div class="content">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'Box',
  props: {
      surroundColor: {
        type: String,
        default: "black"
      },
      surroundImage: {
        type: String,
        default: null
      }
  },
  computed: {
      cssClass() {
          return this.header ? 'header' : '';
      },
      cssStyle() {
        const styles = [
          ['background-color', this.surroundColor],
        ]
        if (this.surroundImage) {
          styles.push(...[
            ['background-image', 'url(' + this.surroundImage + ')'],
            ['background-size', 'cover']
          ])
        }
        let stylestr = ''
        styles.forEach((i) => stylestr += i.join(':') + ';')
        return stylestr
      }
  }
}
</script>

<style lang="scss" scoped>

.wrapper {
    background: black;
    padding: 1rem 2rem;

    &.header {
        padding-top: 0;
    }
}
.content {
    background: white;
    padding: 1rem;
}
</style>
